import { useState } from 'react';
import { getZoomAuthUrl } from 'wisestep-api';
import { WsButton, ZoomLoader } from 'wisestep-base';

import {
  useSmsConfigAccessControl,
  SmsConfigAction,
} from '../../../hooks/useSmsConfigAccessControl';
import { failed } from '../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../utils/NotificationStore';

export interface IAddZoomAccountProps {
  getAccounts: () => Promise<void>;
  setModal: any;
  unMarkModalState: () => Promise<void>;
}

const AddZoomAccount = ({ getAccounts, setModal, unMarkModalState }: IAddZoomAccountProps) => {
  const [loader, setLoader] = useState<boolean>(false);
  const setNotification = useNotificationStore((state) => state.setNotification);
  const { access, owns } = useSmsConfigAccessControl([SmsConfigAction.MANAGE_SMS_CONFIGURATION]);
  const [manageSmsConfig] = access;

  const getUrl = async () => {
    setLoader(true);
    unMarkModalState();
    getZoomAuthUrl()
      .then((response) => {
        window.location.href = response?.data?.url;
        setLoader(true);
        getAccounts();
      })
      .catch((err) => {
        setLoader(false);
        console.log('Error while adding account is ', err);
        setNotification(failed('Error: while adding zoom account!'));
        setModal(false);
      });
  };
  return loader ? (
    <ZoomLoader />
  ) : (
    <WsButton onClick={getUrl} disabled={!(owns || manageSmsConfig)}>
      Add Zoom Account
    </WsButton>
  );
};

export default AddZoomAccount;
